import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


const backend = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
console.log("BACKEND =", backend);
export { backend };
